import { bl_fi_budget_votebook_RowClass } from '../../../dbschema/bl_fi_budget_votebook.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetVotebookContainerModel extends BaseContainerModel {
    bl_fi_budget_votebook: bl_fi_budget_votebook_RowClass = new bl_fi_budget_votebook_RowClass();
}
